<template>
  <component
    :is="forms[step]"
    :type="`sms`"
    :csrf="csrf"
    :position="position"
    :links="links"
    :phone="phone"
    :uid="uid"
    :until="until"
    @go-step="goStep($event)" />
</template>

<script>
import formLoginSmsRequest from './form-login-sms-request.vue';
import formLoginResponse from './form-login-response.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faPhone, faKey, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
library.add(faUser, faPhone, faKey, faArrowLeft);

export default {
  data: function () {
    return {
      forms: ['formLoginSmsRequest', 'formLoginResponse'],
      //
      step: 0,
      phone: '',
      until: '',
      uid: 0,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FontAwesomeIcon,
    formLoginSmsRequest,
    formLoginResponse,
  },
  methods: {
    goStep(event) {
      switch (event.step) {
        // ввести  телефон
        case 0:
          //
          break;
        // ввести код
        case 1:
          this.phone = event.phone;
          break;
      }

      this.uid = event.uid;
      this.until = event.until;

      this.step = event.step;
    },
  },
};
</script>
